// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"db6c0458","453":"0715cede","626":"e9a4dbea"}[chunkId] + ".chunk.js";
};